import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ORDER } from "@/constants/testIds";

const noteKey = (n, idx) => `${n?.at || "no-ts"}-${n?.by || idx}`;

/** Admin-only internal notes section. */
export default function InternalNotesPanel({ order, onAdded }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const add = async () => {
    if (!note.trim()) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/orders/${order.order_id}/notes`, { note });
      onAdded?.(data);
      setNote("");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const notes = order.internal_notes || [];

  return (
    <section className="surface-card mt-8 p-8">
      <div className="overline">Pro Shop Eyes Only</div>
      <h2 className="font-serif text-2xl mt-1 text-[#1A1A1A]">Internal Notes</h2>
      <ul className="mt-5 space-y-3 text-sm">
        {notes.length === 0 && <li className="text-[#7A7A7A]">No internal notes yet.</li>}
        {notes.map((n, i) => (
          <li key={noteKey(n, i)} className="border-l-2 border-[#B59A5A] pl-4">
            <div className="text-[#1A1A1A]">{n.note}</div>
            <div className="text-xs text-[#7A7A7A] mt-1 uppercase tracking-wider">
              {n.by_name || "Pro Shop"} · {new Date(n.at).toLocaleString()}
            </div>
          </li>
        ))}
      </ul>
      <div className="mt-6 flex gap-3 items-end">
        <textarea
          rows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          data-testid={ORDER.detailInternalNote}
          className="input-field flex-1"
          placeholder="Add a private note for the pro shop team"
        />
        <button
          type="button"
          onClick={add}
          disabled={busy || !note.trim()}
          data-testid={ORDER.detailInternalNoteAdd}
          className="btn-accent"
        >
          Add Note
        </button>
      </div>
      {error && (
        <div className="mt-3 px-3 py-2 border border-[#A33] bg-[#fbe9e9] text-[#8a1a1a] text-sm">
          {error}
        </div>
      )}
    </section>
  );
}
